/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import Seccion_Home from "./Secciones/Seccion_Home";
import Footer from "./Footer/Footer";
import Seccion_Testimonios from "./Secciones/Seccion_Testimonios";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Seccion_Pagina_Personal from "./Secciones/Seccion_Pagina_Personal";
import {useEffect, useState} from "react";
import {obtenerSeccion} from "../Utilidades/obtenerSeccion";

const Pagina = () => {
    const [esLimpia, setESLimpias] = useState(false);


    useEffect(() => {

        let path = window.location.pathname;
        console.log(path)
        let secc = obtenerSeccion(path)
        console.log(secc)
        if (secc === 'Pagina') {
            setESLimpias(true);
        } else {
            setESLimpias(false);
        }


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Router>
                {!esLimpia &&
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Barra/>
                    </Grid>
                }

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/"} element={<Seccion_Home/>}/>
                        <Route path={"/Home"} element={<Seccion_Home/>}/>
                        <Route path={"/Testimonios"} element={<Seccion_Testimonios/>}/>
                        <Route path={"/Pagina/:id"} element={<Seccion_Pagina_Personal/>}/>
                    </Routes>
                </Grid>

                {!esLimpia &&
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                        <Footer/>
                    </Grid>
                }
            </Router>

        </Grid>
    )

}
export default Pagina    